import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const ZoomOutIcon = createIcon(
  'ZoomOut',
  // @todo replace with path
  <rect width="14" height="2.333" x="5" y="11" rx="1.167" />
);

ZoomOutIcon.warning = true;

export default ZoomOutIcon;
